import { render, staticRenderFns } from "./deliveryRoutesTable.vue?vue&type=template&id=5b06350c&"
import script from "./deliveryRoutesTable.vue?vue&type=script&lang=ts&"
export * from "./deliveryRoutesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports